const createHistory = require("history").createBrowserHistory;

const history = createHistory({
    basename: process.env.PUBLIC_URL
});

export { history };
